const DOMAIN_PATTERN = /^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?(?:\/|$|\?)/i;

export function normalizeImageUrl(raw: unknown): string | null {
  if (typeof raw !== 'string') {
    return null;
  }

  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }

  const prefixed =
    trimmed.startsWith('//')
      ? `https:${trimmed}`
      : /^[a-z]+:\/\//i.test(trimmed)
        ? trimmed
        : DOMAIN_PATTERN.test(trimmed)
          ? `https://${trimmed}`
          : null;

  if (!prefixed) {
    return null;
  }

  try {
    const parsed = new URL(prefixed);
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return null;
    }
    return parsed.toString();
  } catch {
    return null;
  }
}

export function buildImageProxySrc(raw: unknown): string | null {
  const normalized = normalizeImageUrl(raw);
  if (!normalized) {
    return null;
  }
  return `/api/datasets/image-proxy?url=${encodeURIComponent(normalized)}`;
}

export function rewriteTopLevelScreenshotUrl(record: Record<string, unknown>): void {
  for (const key of ['screenshot_url', 'screenshotUrl'] as const) {
    if (!(key in record)) {
      continue;
    }

    const proxied = buildImageProxySrc(record[key]);
    if (proxied) {
      record[key] = proxied;
    }
  }
}
